import { render, staticRenderFns } from "./PostComplaintModal.vue?vue&type=template&id=023a50a4&"
import script from "./PostComplaintModal.vue?vue&type=script&lang=js&"
export * from "./PostComplaintModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports